<template>
    <div>
          <v-container class="my-2" >

                <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl" > Mensagens</h1>

          </v-container>

          <v-row justify="center" >
              <v-col cols="10" class="mb-2" >
               
                <v-row v-for="item in items" :key="item.id" class="grey lighten-2 rounded-tl-xl mb-2" >
                    <v-col cols="3" class="pa-3 mr-2" >
                        <v-row class="pa-5">
                            
                            <v-col cols="12">
                                <p>Nome: {{ item.nome }}</p>
                                <span>Enviado às: </span>
                                <p><span><strong>{{ new Date(item.hora).getDate() }}/{{new Date(item.hora).getMonth()}} - {{new Date(item.hora).getHours()}}:{{new Date(item.hora).getMinutes()}}</strong></span></p>
                                <span>Telefone</span>
                                <p><strong>{{item.telefone}}</strong></p>
                                <p><v-btn @click="apagar(item)" icon class="red white--text"><v-icon>mdi-delete</v-icon></v-btn></p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="8" class="white my-3" >
                        <p>{{ item.email }}</p>
                        <p>{{ item.texto }}</p>
                    </v-col>
                </v-row>
                
              </v-col>
          </v-row>
    </div>
</template>

<script>
import {refMensagens} from '@/firebaseConfig'
import firebase from 'firebase/app'
import 'firebase/firestore'
import {mapGetters} from 'vuex'
import CryptoJS from 'crypto-js'
    export default {
        data(){
            return {
                valid: true,
                refMensagens: refMensagens,
                items: {},
            }
        },
        computed: {
            ...mapGetters(["getCurrentUser"]),
            chaveUsuarioMensagens(){
                const usuario = this.getCurrentUser
                const identificador = usuario && (usuario.email || usuario.uid)
                return identificador
                    ? CryptoJS.MD5(String(identificador).trim().toLowerCase()).toString()
                    : null
            }
        },
        created(){
            this.carregarMensagens()
        },
        methods: {
            async carregarMensagens(){
                 this.items = [];
                 return this.refMensagens.orderBy("hora","desc").get().then((snap) =>  {
                     snap.forEach( (doc) =>  {
                        
                         const mensagem = {...doc.data(), id: doc.id}
                         this.items.push(mensagem);
                         this.updateMensagem(mensagem);
                    });
                });
            },
            async updateMensagem(mensagem){
                const chaveUsuario = this.chaveUsuarioMensagens
                if(!chaveUsuario){
                    return
                }

                const lidasPor = Array.isArray(mensagem.lidaPor) ? mensagem.lidaPor : []
                const mensagemJaLida = lidasPor.includes(chaveUsuario) ||
                    (!Array.isArray(mensagem.lidaPor) && mensagem.lida === true)

                if(mensagemJaLida){
                    return
                }

                await this.refMensagens.doc(mensagem.id).update({
                    lida: true,
                    lidaPor: firebase.firestore.FieldValue.arrayUnion(chaveUsuario)
                });
            },
            apagar(item){
                
                if(confirm("Deseja apagar mesmo?")){
                    this.refMensagens.doc(item.id).delete().then(() =>{
                    console.log("Apagado!");
                    this.$toasted.global.defaultSuccess("Apagado com sucesso!");
                    /*var index = this.items.indexOf(item);
                    if (index > -1) {
                        this.items.splice(index, 1);
                    }*/
                this.carregarMensagens();
                });
                }
                
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
